import * as valueListActionTypes from './valueListActionTypes';

export const addValueList = (valueKey, valueList) =>
    ({ type: valueListActionTypes.ADD_VALUE_LIST, valueKey: valueKey, valueList: valueList });

export const removeValueList = (valueKey) =>
    ({ type: valueListActionTypes.REMOVE_VALUE_LIST, valueKey: valueKey });